// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1566":"ff10b404","6254":"ff10b404"}[chunkId] + ".chunk.css";
};